import React from 'react';
import { IGlobalStorefrontSettings, IStorefrontSettings } from '../../../models/Storefront';
import { useGetStorefrontCategoriesQuery } from '../../../store/endpoints/StorefrontProductEndpoints';
import { Callout, Toggle } from '@fluentui/react';
import { EditPencil } from './styleControls';

interface IStorefrontCategoryEditorProps {
    globalSettings: IGlobalStorefrontSettings;
    storefrontSettings: IStorefrontSettings;
    onStorefrontSettingsChange: (newSettings: IStorefrontSettings) => void;
    editMode?: boolean;
    subUrl?: string;
    isDark?: boolean;
    // When provided (Home editor edit mode), a hover pencil opens the category pod style panel.
    onEditStyle?: () => void;
}

const StorefrontCategoryEditor: React.FC<IStorefrontCategoryEditorProps> = (props) => {
    const categories = useGetStorefrontCategoriesQuery({ subUrl: props.subUrl ?? '' }, { skip: props.subUrl == null });
    const targetRef = React.useRef<HTMLDivElement>(null);
    const [calloutOpen, setCalloutOpen] = React.useState(false);

    if (!props.editMode && !props.storefrontSettings.useCategories) {
        return null;
    }

    return <div>
        <div
            className={`storefront-category-container ${props.editMode ? 'storefront-category-container-edit' : ''}${props.onEditStyle ? ' sf-pencil-host' : ''}`}
            ref={targetRef}
            onClick={() => {
                if (props.editMode) {
                    setCalloutOpen(true);
                }
            }}
            >
                {props.onEditStyle && <EditPencil onClick={props.onEditStyle} title='Edit category pod style' />}
                {categories.data?.items.map((category, index) => (
                    <div key={index} className={`storefront-category-pod-button${props.isDark ? ' storefront-category-pod-button-dark' : ''}`}>
                        {category.smallImageUrl ? <img src={category.smallImageUrl} alt={category.label} style={{ maxWidth: '100%', maxHeight: 100, objectFit: 'contain', filter: props.isDark ? 'invert(1)' : undefined }} /> : null}
                        <div className='storefront-category-pod-name'>{category.label ?? category.identifier}</div>
                    </div>
                ))}
        </div>
        {calloutOpen && <Callout
            target={targetRef.current}
            onDismiss={() => setCalloutOpen(false)}
            isBeakVisible={true}
            gapSpace={10}
            style={{padding: '1em'}}
        >
                <h3>Category Settings</h3>
                <Toggle
                    inlineLabel
                    label={'Show Categories'}
                    checked={props.storefrontSettings.useCategories == null ? props.globalSettings.useCategories : props.storefrontSettings.useCategories}
                    onChange={(_, checked) => {
                        props.onStorefrontSettingsChange({ ...props.storefrontSettings, useCategories: checked });
                    }}
                    />
        </Callout>}
    </div>
}

export default StorefrontCategoryEditor;